<template>
	<div class="setting-template">
		<el-form
      ref="settingTemplate"
      label-width="150px"
    >
			<el-form-item label="Type">
				<el-select v-model="setting_type" @change="chooseSettingType">
					<el-option
						v-for="type in setting_templates"
						:key="type.key"
						:label="type.value"
						:value="type.value">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="Model">
				<el-select v-model="model" @change="chooseModel">
					<el-option
						v-for="obj in data_model"
						:key="obj.key"
						:label="obj.label"
						:value="obj.value">
					</el-option>
				</el-select>
			</el-form-item>
		</el-form>

		<el-row :gutter="24">
			<el-col :span="12">
				<div class="board-column collection">
					<div class="board-column-header">
						Collections ({{ collections.length }}/{{ initCollections.length }})
					</div>
					<div class="board-column-content">
            <el-checkbox-group v-model="collections">
              <el-checkbox
                v-for="collection in initCollections"
                :key="collection.id"
                :label="collection.id"
                class="board-item"
                @change="changeCollection($event, collection.id)"
              >
                {{ collection.title }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
				</div>
			</el-col>
			<el-col :span="12">
				<div class="board-column template">
					<div class="board-column-header">
						Templates ({{ templates.length }}/{{ initTemplates.length }})
					</div>
					<div class="board-column-content">
            <el-checkbox-group v-model="templates">
              <el-checkbox
                v-for="template in initTemplates"
                :key="template.id"
                :label="template.id"
                class="board-item"
              >
                {{ template.name }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
				</div>
			</el-col>
		</el-row>
    <div class="text-center mt-5">
      <el-button @click="saveSettingTemplate" type="primary" :disabled="isLoading">
        <i v-if="isLoading" class="el-icon-loading"></i>
        Save
      </el-button>
    </div>
	</div>
</template>
<script>

import { SETTING_TEMPLATE_TYPE } from '@/constants/template'
import { mapActions, mapState } from 'vuex'

export default {
	computed: {
		setting_templates() {
			return SETTING_TEMPLATE_TYPE.map(setting => {
				return {
					key: setting,
					value: setting
				}
			})
		},
    ...mapState({
      initCollections: state => state.collection.collections,
      initTemplates: state => state.collection.templates,
    }),
	},
	data() {
		return {
			setting_type: null,
			model: null,
			data_model: [],
			collections: [],
      templates: [],
      isLoading: false
		}
	},
	created() {
		this.getCollections()
	},
	methods: {
		...mapActions('admin_user', ['getUsers', 'settingTemplateUser', 'getCollectionUser', 'getTemplateUser']),
    ...mapActions('collection', ['getCollections']),
		...mapActions('admin_organizations', ['getList', 'getCollectionOrg', 'settingTemplateOrg', 'getTemplateOrg']),
		async chooseSettingType() {
      this.model = null
			if (this.setting_type === 'user') {
				await this.getUsers()
				const data = this.$store.state.admin_user.users
				this.data_model = data.map(user => {
					return {
						key: user.id,
						value: user.id,
						label: user.email
					}
				})
			}
			if (this.setting_type === 'organization') {
				await this.getList()
				const data = this.$store.state.admin_organizations.organizations
				this.data_model = data.map(organization => {
					return {
						key: organization.id,
						value: organization.id,
						label: organization.name
					}
				})
			}
		},
		async chooseModel() {
      let collections
			let templates
      if (this.setting_type === 'organization') {
				await this.getCollectionOrg({ id: this.model })
        await this.getTemplateOrg({ id: this.model })
				collections = this.$store.state.admin_organizations.collections
        templates = this.$store.state.admin_organizations.templates
        this.collections = collections.map(collection => collection.id)
        this.templates = templates.map(template => template.id)
			}
      if (this.setting_type === 'user') {
				await this.getCollectionUser({ id: this.model })
        await this.getTemplateUser({ id: this.model })
				collections = this.$store.state.admin_user.collections
        templates = this.$store.state.admin_user.templates
        console.log(templates)
        this.collections = collections.map(collection => collection.id)
        this.templates = templates.map(template => template.id)
			}
		},
		changeCollection(e, collection_id) {
      const collections = this.initCollections.filter(collection => collection.id === collection_id)
      let templates = []
      if (collections.length > 0) {
        templates = collections[0].templates.map(template => template.id)
      }
      if (e) {
        this.templates = [...new Set(this.templates.concat(templates))]
      } else {
        templates.map(template => {
          this.templates = this.templates.filter(tpl => tpl !== template)
        })
      }
		},
    saveSettingTemplate() {
      if (!this.setting_type || !this.model) return
      if (this.setting_type === 'organization') {
        this.settingTemplateOrg({
          id: this.model,
          collections: this.collections,
          templates: this.templates
        })
      }
      if (this.setting_type === 'user') {
        this.settingTemplateUser({
          id: this.model,
          collections: this.collections,
          templates: this.templates
        })
      }
    }
	}
}
</script>
<style lang="scss">
  .setting-template {
		.board-column {
			min-width: 300px;
			min-height: 100px;
			height: auto;
			overflow: hidden;
			background: #f0f0f0;
			border-radius: 3px;

			&.collection {
				.board-column-header {
					background: #4A9FF9;
				}
			}
			&.template {
				.board-column-header {
					background: #f9944a;
				}
			}
			.board-column-header {
				height: 50px;
				line-height: 50px;
				overflow: hidden;
				padding: 0 20px;
				text-align: center;
				background: #333;
				color: #fff;
				border-radius: 3px 3px 0 0;
			}
			.board-column-content {
				max-height: 550px;
        overflow: scroll;
        border: 10px solid transparent;
        min-height: 60px;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        align-items: center;
        overflow-x: hidden;
				.board-item {
					cursor: pointer;
					width: 100%;
					height: 64px;
					margin: 5px 0;
					background-color: #fff;
					text-align: left;
					line-height: 54px;
					padding: 5px 10px;
					box-sizing: border-box;
					box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.2);
				}
			}
		}	
	}
</style>